import React, { useState } from "react";
import Header from "../../components/Header/Header";
import InputBox from "../../components/InputBox/InputBox";
import PeerCards from "../../components/PeerCards/PeerCards";
import PeerForm from "../../components/PeerForm/PeerForm";

const Home = () => {
  const [apiKey, setApiKey] = useState(null);
  const [hasApiKey, setHasApiKey] = useState(null);
  const [newPeerAdded, setNewPeerAdded] = useState(false);

  return (
    <div className="mx-[5%]">
      <Header />
      <InputBox
        apiKey={apiKey}
        setApiKey={setApiKey}
        hasApiKey={hasApiKey}
        setHasApiKey={setHasApiKey}
      />
      {hasApiKey ? (
        <>
          <PeerForm newPeerAdded={newPeerAdded} setNewPeerAdded={setNewPeerAdded} />
          <PeerCards
            hasApiKey={hasApiKey}
            setHasApiKey={setHasApiKey}
            newPeerAdded={newPeerAdded}
            setNewPeerAdded={setNewPeerAdded}
          />
        </>
      ) : null}
    </div>
  );
};

export default Home;
